var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "活动名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.activityName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "activityName", $$v)
                      },
                      expression: "searchInfo.activityName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.activityStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "activityStatus", $$v)
                        },
                        expression: "searchInfo.activityStatus"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "启用", value: 1 } },
                        [_vm._v("启用")]
                      ),
                      _c(
                        "el-option",
                        { key: 2, attrs: { label: "禁用", value: 2 } },
                        [_vm._v("禁用")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "审核状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.auditStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "auditStatus", $$v)
                        },
                        expression: "searchInfo.auditStatus"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "待审核", value: 1 } },
                        [_vm._v("待审核")]
                      ),
                      _c(
                        "el-option",
                        { key: 2, attrs: { label: "通过", value: 2 } },
                        [_vm._v("通过")]
                      ),
                      _c(
                        "el-option",
                        { key: 3, attrs: { label: "不通过", value: 3 } },
                        [_vm._v("不通过")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.onAdd }
                    },
                    [_vm._v("新增活动")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "row-dblclick": _vm.onRowdbclick
          }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: { label: "活动编号", prop: "activityNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "活动名称", prop: "activityName" }
          }),
          _c("el-table-column", {
            attrs: { label: "开始时间", prop: "dateStart" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.dateStart)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "结束时间", prop: "dateEnd" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.dateEnd)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "活动状态", prop: "activityStatus" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "warn", effect: "plain" } },
                          [_vm._v("待审核")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 3
                      ? _c(
                          "el-tag",
                          { attrs: { type: "error", effect: "plain" } },
                          [_vm._v("审核不通过")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2 && scope.row.activityStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", effect: "plain" } },
                          [_vm._v("已启用")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2 && scope.row.activityStatus == 2
                      ? _c(
                          "el-tag",
                          { attrs: { type: "error", effect: "plain" } },
                          [_vm._v("已禁用")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "300px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onView(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    ),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onUpdate(scope.row)
                              }
                            }
                          },
                          [_vm._v("变更")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onAudit(scope.row)
                              }
                            }
                          },
                          [_vm._v("审核")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onAble(scope.row)
                              }
                            }
                          },
                          [_vm._v("启用")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.onDisable(scope.row)
                              }
                            }
                          },
                          [_vm._v("禁用")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.onDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-invite-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-steps",
                {
                  attrs: {
                    active: _vm.stepActive,
                    "finish-status": "success",
                    "align-center": ""
                  }
                },
                [
                  _c("el-step", { attrs: { title: "活动规则" } }),
                  _c("el-step", { attrs: { title: "邀请页面" } }),
                  _c("el-step", { attrs: { title: "被邀请页面" } }),
                  _c("el-step", { attrs: { title: "分享配置" } })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 6 } }, [_vm._v(" ")]),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "活动名称：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.activityName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "activityName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.activityName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("el-form-item", [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          "注意：新用户完成加油支付才算邀请成功"
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "活动时间：" } },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "datetimerange",
                                          align: "right",
                                          "unlink-panels": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始(含当天)",
                                          "end-placeholder": "结束(含当天)",
                                          format: "yyyy-MM-dd HH:mm:ss",
                                          "value-format": "yyyy-MM-dd HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.dateRangeValueArr,
                                          callback: function($$v) {
                                            _vm.dateRangeValueArr = $$v
                                          },
                                          expression: "dateRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "最低支付金额：" } },
                                    [
                                      _c("el-input-number", {
                                        model: {
                                          value: _vm.formData.limitPayMoney,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "limitPayMoney",
                                              $$v
                                            )
                                          },
                                          expression: "formData.limitPayMoney"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bairun-form-item-label-suffix"
                                        },
                                        [_vm._v("元")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("el-form-item", [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          "注意：被邀请最低支付x元才算邀请成功"
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "每邀请：" } },
                                    [
                                      _c("el-input-number", {
                                        model: {
                                          value: _vm.formData.inviteNum,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "inviteNum",
                                              $$v
                                            )
                                          },
                                          expression: "formData.inviteNum"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bairun-form-item-label-suffix"
                                        },
                                        [_vm._v("人")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "邀请者赠送：" } },
                                    _vm._l(
                                      _vm.formData.inviteTicketList,
                                      function(item, index) {
                                        return _c(
                                          "el-row",
                                          { staticClass: "ticket-form-item" },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 8 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: { label: "券编号" }
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      model: {
                                                        value:
                                                          item.ticketRuleNo,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "ticketRuleNo",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.ticketRuleNo"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 8 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  { attrs: { label: "数量" } },
                                                  [
                                                    _c("el-input-number", {
                                                      model: {
                                                        value: item.num,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "num",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.num"
                                                      }
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "bairun-form-item-label-suffix"
                                                      },
                                                      [_vm._v("张")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "被邀请者赠送：" } },
                                    _vm._l(
                                      _vm.formData.invitedTicketList,
                                      function(item, index) {
                                        return _c(
                                          "el-row",
                                          { staticClass: "ticket-form-item" },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 8 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: { label: "券编号" }
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      model: {
                                                        value:
                                                          item.ticketRuleNo,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "ticketRuleNo",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.ticketRuleNo"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 8 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  { attrs: { label: "数量" } },
                                                  [
                                                    _c("el-input-number", {
                                                      model: {
                                                        value: item.num,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "num",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.num"
                                                      }
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "bairun-form-item-label-suffix"
                                                      },
                                                      [_vm._v("张")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "小程序弹窗通知：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.isShowDialog,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "isShowDialog",
                                                $$v
                                              )
                                            },
                                            expression: "formData.isShowDialog"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("弹窗")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("不弹窗")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "审核结果：" } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.auditStatus,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "auditStatus",
                                                $$v
                                              )
                                            },
                                            expression: "formData.auditStatus"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("待审核")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("通过")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 3 } },
                                            [_vm._v("不通过")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "审核意见：" } },
                                    [
                                      _c("el-input", {
                                        attrs: { type: "textarea", rows: "5" },
                                        model: {
                                          value: _vm.formData.auditRemark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "auditRemark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.auditRemark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("el-col", { attrs: { span: 6 } }, [_vm._v(" ")])
            ],
            1
          ),
          _vm.stepActive == 2
            ? _c(
                "el-form",
                {
                  ref: "formData2",
                  attrs: { model: _vm.formData, "label-position": "right" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券文案：" } },
                                    [
                                      _c("el-input", {
                                        attrs: { type: "textarea" },
                                        model: {
                                          value: _vm.formData.inviteTicketText,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "inviteTicketText",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.inviteTicketText"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "活动说明：" } },
                                    [
                                      _c("el-input", {
                                        attrs: { type: "textarea", rows: "10" },
                                        model: {
                                          value:
                                            _vm.formData.inviteActivityText,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "inviteActivityText",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.inviteActivityText"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "" } }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/invite_activity_demo.png"),
                                alt: ""
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.stepActive == 3
            ? _c(
                "el-form",
                {
                  ref: "formData3",
                  attrs: { model: _vm.formData, "label-position": "right" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "券文案：" } },
                                    [
                                      _c("el-input", {
                                        attrs: { type: "textarea" },
                                        model: {
                                          value: _vm.formData.invitedTicketText,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "invitedTicketText",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.invitedTicketText"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "活动说明：" } },
                                    [
                                      _c("el-input", {
                                        attrs: { type: "textarea", rows: "10" },
                                        model: {
                                          value:
                                            _vm.formData.invitedActivityText,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "invitedActivityText",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.invitedActivityText"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "" } }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/invited_activity_demo.png"),
                                alt: ""
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.stepActive == 4
            ? _c(
                "el-form",
                {
                  ref: "formData3",
                  attrs: { model: _vm.formData, "label-position": "right" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "分享标题：" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.formData.shareTitle,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "shareTitle",
                                              $$v
                                            )
                                          },
                                          expression: "formData.shareTitle"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "分享好友图标：" } },
                                    [
                                      _c("img", {
                                        staticClass: "bairun-share-app-logo",
                                        attrs: {
                                          src: _vm.formData.shareAppLogo
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "分享朋友圈图标：" } },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "bairun-share-timeline-logo",
                                        attrs: {
                                          src: _vm.formData.shareTimeLineLogo
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "" } }, [
                            _c("img", {
                              staticStyle: { width: "90%" },
                              attrs: {
                                src: require("@/assets/share-demo.png"),
                                alt: ""
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.addDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-invite-activity-add bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.addDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-steps",
                {
                  attrs: {
                    active: _vm.stepActive,
                    "finish-status": "success",
                    "align-center": ""
                  }
                },
                [
                  _c("el-step", { attrs: { title: "活动规则" } }),
                  _c("el-step", { attrs: { title: "邀请页面" } }),
                  _c("el-step", { attrs: { title: "被邀请页面" } }),
                  _c("el-step", { attrs: { title: "分享配置" } })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")]),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _vm.stepActive == 1
                    ? _c(
                        "el-form",
                        {
                          ref: "formData",
                          attrs: {
                            model: _vm.formData,
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "活动名称：",
                                        prop: "activityName"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "请输入" },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          }
                                        },
                                        model: {
                                          value: _vm.formData.activityName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "activityName",
                                              $$v
                                            )
                                          },
                                          expression: "formData.activityName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("el-form-item", [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          "注意：新用户完成加油支付才算邀请成功"
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "活动时间：",
                                        prop: "dateRangeValueArr"
                                      }
                                    },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "datetimerange",
                                          align: "right",
                                          "unlink-panels": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始(含当天)",
                                          "end-placeholder": "结束(含当天)",
                                          format: "yyyy-MM-dd HH:mm:ss",
                                          "value-format": "yyyy-MM-dd HH:mm:ss"
                                        },
                                        model: {
                                          value: _vm.dateRangeValueArr,
                                          callback: function($$v) {
                                            _vm.dateRangeValueArr = $$v
                                          },
                                          expression: "dateRangeValueArr"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "最低支付金额：",
                                        prop: "limitPayMoney"
                                      }
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          clearable: "",
                                          placeholder:
                                            "被邀请最低支付x元才算邀请成功"
                                        },
                                        model: {
                                          value: _vm.formData.limitPayMoney,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "limitPayMoney",
                                              $$v
                                            )
                                          },
                                          expression: "formData.limitPayMoney"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bairun-form-item-label-suffix"
                                        },
                                        [_vm._v("元")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("el-form-item", [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          "注意：被邀请最低支付x元才算邀请成功"
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "每邀请：",
                                        prop: "inviteNum"
                                      }
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          clearable: "",
                                          placeholder: "请输入"
                                        },
                                        model: {
                                          value: _vm.formData.inviteNum,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "inviteNum",
                                              $$v
                                            )
                                          },
                                          expression: "formData.inviteNum"
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bairun-form-item-label-suffix"
                                        },
                                        [_vm._v("人")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "小程序弹窗通知：",
                                        prop: "isShowDialog"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "small" },
                                          model: {
                                            value: _vm.formData.isShowDialog,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "isShowDialog",
                                                $$v
                                              )
                                            },
                                            expression: "formData.isShowDialog"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("弹窗")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("不弹窗")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: { label: "邀请者赠送：" }
                                    },
                                    _vm._l(
                                      _vm.formData.inviteTicketList,
                                      function(item, index) {
                                        return _c(
                                          "el-row",
                                          { staticClass: "ticket-form-item" },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 8 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "券编号",
                                                      prop:
                                                        "inviteTicketList." +
                                                        index +
                                                        ".ticketRuleNo"
                                                    }
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      attrs: {
                                                        disabled:
                                                          _vm.type == "update",
                                                        clearable: "",
                                                        placeholder:
                                                          "输入券编号"
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          return _vm.getTicketDetail(
                                                            item
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          item.ticketRuleNo,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "ticketRuleNo",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.ticketRuleNo"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 8 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "数量",
                                                      prop:
                                                        "inviteTicketList." +
                                                        index +
                                                        ".num"
                                                    }
                                                  },
                                                  [
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        disabled:
                                                          _vm.type == "update",
                                                        clearable: "",
                                                        placeholder:
                                                          "请输入张数",
                                                        min: 1
                                                      },
                                                      model: {
                                                        value: item.num,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "num",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.num"
                                                      }
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "bairun-form-item-label-suffix"
                                                      },
                                                      [_vm._v("张")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm.type != "update"
                                              ? _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "btn-tool-balancrange",
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDeleteInviteTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("-")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.type != "update"
                                              ? _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onAddInviteTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("+")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: { label: "被邀请者赠送：" }
                                    },
                                    _vm._l(
                                      _vm.formData.invitedTicketList,
                                      function(item, index) {
                                        return _c(
                                          "el-row",
                                          { staticClass: "ticket-form-item" },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 8 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "券编号",
                                                      prop:
                                                        "invitedTicketList." +
                                                        index +
                                                        ".ticketRuleNo"
                                                    }
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      attrs: {
                                                        disabled:
                                                          _vm.type == "update",
                                                        clearable: "",
                                                        placeholder:
                                                          "输入券编号"
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          return _vm.getTicketDetail(
                                                            item
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          item.ticketRuleNo,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "ticketRuleNo",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.ticketRuleNo"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 8 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "数量",
                                                      prop:
                                                        "invitedTicketList." +
                                                        index +
                                                        ".num"
                                                    }
                                                  },
                                                  [
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        disabled:
                                                          _vm.type == "update",
                                                        clearable: "",
                                                        placeholder:
                                                          "请输入张数",
                                                        min: 1
                                                      },
                                                      model: {
                                                        value: item.num,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "num",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.num"
                                                      }
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "bairun-form-item-label-suffix"
                                                      },
                                                      [_vm._v("张")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm.type != "update"
                                              ? _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "btn-tool-balancrange",
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onDeleteInvitedTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("-")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.type != "update"
                                              ? _c(
                                                  "el-col",
                                                  {
                                                    staticClass:
                                                      "btn-tool-balancrange",
                                                    attrs: { span: 2 }
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      [
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onAddInvitedTicket(
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("+")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")])
            ],
            1
          ),
          _vm.stepActive == 2
            ? _c(
                "el-form",
                {
                  ref: "formData2",
                  attrs: { model: _vm.formData, "label-position": "right" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "券文案：",
                                        prop: "inviteTicketText"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          placeholder: "最多2行",
                                          rows: "2"
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          }
                                        },
                                        model: {
                                          value: _vm.formData.inviteTicketText,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "inviteTicketText",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.inviteTicketText"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "活动说明：",
                                        prop: "inviteActivityText"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          placeholder: "行数不限制",
                                          rows: "5"
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.formData.inviteActivityText,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "inviteActivityText",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.inviteActivityText"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "" } }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/invite_activity_demo.png"),
                                alt: ""
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.stepActive == 3
            ? _c(
                "el-form",
                {
                  ref: "formData3",
                  attrs: { model: _vm.formData, "label-position": "right" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "券文案：",
                                        prop: "invitedTicketText"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          placeholder: "最多两行",
                                          rows: "2"
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          }
                                        },
                                        model: {
                                          value: _vm.formData.invitedTicketText,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "invitedTicketText",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.invitedTicketText"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "活动说明：",
                                        prop: "invitedActivityText"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          placeholder: "行数不限制",
                                          rows: "5"
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.formData.invitedActivityText,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "invitedActivityText",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.invitedActivityText"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "" } }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/invited_activity_demo.png"),
                                alt: ""
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.stepActive == 4
            ? _c(
                "el-form",
                {
                  ref: "formData3",
                  attrs: { model: _vm.formData, "label-position": "right" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "分享标题：",
                                        prop: "shareTitle"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入分享标题"
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange($event)
                                          }
                                        },
                                        model: {
                                          value: _vm.formData.shareTitle,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "shareTitle",
                                              $$v
                                            )
                                          },
                                          expression: "formData.shareTitle"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "分享好友图标：",
                                        prop: "shareAppLogo"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          staticClass:
                                            "bairun-share-app-uploader",
                                          attrs: {
                                            action:
                                              _vm.path +
                                              "/fileUploadAndDownload/upload",
                                            "before-upload":
                                              _vm.checkShareAppFile,
                                            headers: { "x-token": _vm.token },
                                            "on-error": _vm.uploadError,
                                            "on-success":
                                              _vm.uploadShareAppSuccess,
                                            "show-file-list": false
                                          }
                                        },
                                        [
                                          _vm.formData.shareAppLogo
                                            ? _c("img", {
                                                staticClass:
                                                  "bairun-share-app-logo",
                                                attrs: {
                                                  src: _vm.formData.shareAppLogo
                                                }
                                              })
                                            : _c("i", {
                                                staticClass:
                                                  "el-icon-plus bairun-share-app-uploader-icon"
                                              })
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "bairun-share-uploader-rule"
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              "只能上传jpg/png文件，且不超过500kb"
                                            )
                                          ]),
                                          _c("div", [
                                            _vm._v("500px * 400px（宽*高）")
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "分享朋友圈图标：",
                                        prop: "shareTimeLineLogo"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          staticClass:
                                            "bairun-share-timeline-uploader",
                                          attrs: {
                                            action:
                                              _vm.path +
                                              "/fileUploadAndDownload/upload",
                                            "before-upload":
                                              _vm.checkShareTimeLineFile,
                                            headers: { "x-token": _vm.token },
                                            "on-error": _vm.uploadError,
                                            "on-success":
                                              _vm.uploadShareTimeLineSuccess,
                                            "show-file-list": false
                                          }
                                        },
                                        [
                                          _vm.formData.shareTimeLineLogo
                                            ? _c("img", {
                                                staticClass:
                                                  "bairun-share-timeline-logo",
                                                attrs: {
                                                  src:
                                                    _vm.formData
                                                      .shareTimeLineLogo
                                                }
                                              })
                                            : _c("i", {
                                                staticClass:
                                                  "el-icon-plus bairun-share-timeline-uploader-icon"
                                              })
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "bairun-share-timeline-rule"
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              "只能上传jpg/png文件，且不超过500kb"
                                            )
                                          ]),
                                          _c("div", [
                                            _vm._v("200px * 200px（宽*高）")
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "" } }, [
                            _c("img", {
                              staticStyle: { width: "90%" },
                              attrs: {
                                src: require("@/assets/share-demo.png"),
                                alt: ""
                              }
                            })
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addBefore } },
                [_vm._v("上一步")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addNext } },
                [_vm._v("下一步")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("提 交")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.auditDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-audit bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.auditDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")]),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "审核结果：",
                                    prop: "auditStatus"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.formData.auditStatus,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "auditStatus",
                                            $$v
                                          )
                                        },
                                        expression: "formData.auditStatus"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("通过")
                                      ]),
                                      _c("el-radio", { attrs: { label: 3 } }, [
                                        _vm._v("不通过")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "审核意见：",
                                    prop: "auditRemark"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入",
                                      rows: "5"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.auditRemark,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "auditRemark",
                                          $$v
                                        )
                                      },
                                      expression: "formData.auditRemark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("提 交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }